module.exports = __webpack_public_path__ + "static/media/rankings-icon.9d9a9cca.svg";